angular
    .module("skillBuilderSaaS")
    .directive("sizeModal", function () {
    return {
        restrict: "A",
        link: function (_scope, element, $attrs) {
            if ($attrs.sizeModal > 0) {
                $(element).parents(".modal-dialog").width($attrs.sizeModal);
                //Since we're fixing the size of the modal, we should enable scrolling
                $(element).parents(".modal").css("overflow-x", "auto");
            }
        }
    };
});
